import { AddCard } from '@mui/icons-material';
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  MenuItem,
  Select,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
} from '@mui/material';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import { get } from 'lodash';
import React from 'react';

export default function AddTransactionDialog({
  addTransaction,
  addTransactionDialogOpen,
  setAddTransactionDialogOpen,
  errMessage,
  setErrMessage,
  setSnackOpen,
  companies,
}) {
  const initialAddTransactionFormData = Object.freeze({
    timestamp: new Date(),
    shares: 1,
    price: 1,
    companyId: '',
    type: 'BUY',
  });
  const [addTransactionFormData, setAddTransactionFormData] = React.useState(
    initialAddTransactionFormData,
  );

  const handleDateChange = (newValue) => {
    setAddTransactionFormData({
      ...addTransactionFormData,
      timestamp: newValue,
    });
  };

  const handleAddTransaction = (event) => {
    event.preventDefault();

    setAddTransactionFormData({
      ...addTransactionFormData,
      [event.target.name]: event.target.value,
    });
  };

  const handleCompanyChange = (event) => {
    setAddTransactionFormData({
      ...addTransactionFormData,
      companyId: event.target.value,
    });
  };

  const handleTypeChange = (event) => {
    setAddTransactionFormData({
      ...addTransactionFormData,
      type: event.target.value,
    });
  };

  const handleAddTransactionSubmit = async (event) => {
    event.preventDefault();

    try {
      const { timestamp, shares, price, companyId, type } =
        addTransactionFormData;
      await addTransaction({
        timestamp: timestamp.toISOString(),
        shares,
        price,
        companyId,
        type,
      });
      setAddTransactionDialogOpen(false);
    } catch (err) {
      setErrMessage(get(err, 'response.data.message', errMessage));
      setSnackOpen(true);
    }
  };

  return (
    <Dialog
      open={addTransactionDialogOpen}
      onClose={() => setAddTransactionDialogOpen(false)}
    >
      <DialogTitle>Add transaction</DialogTitle>
      <DialogContent>
        <form onSubmit={handleAddTransactionSubmit}>
          <Box style={{ margin: 10 }}>
            <Select
              name="companyId"
              label="Company"
              value={addTransactionFormData.companyId}
              onChange={handleCompanyChange}
              fullWidth
            >
              <MenuItem value="">
                <em>Select a company</em>
              </MenuItem>
              {companies.map((company) => (
                <MenuItem key={company.id} value={company.id}>
                  {company.name} ({company.symbol})
                </MenuItem>
              ))}
            </Select>
          </Box>
          <Box style={{ margin: 10 }}>
            <ToggleButtonGroup
              value={addTransactionFormData.type}
              exclusive
              onChange={handleTypeChange}
              fullWidth
            >
              <ToggleButton
                value="BUY"
                sx={{
                  '&.Mui-selected': {
                    backgroundColor: '#4caf50',
                    color: '#fff',
                    '&:hover': {
                      backgroundColor: '#45a049',
                    },
                  },
                }}
              >
                Buy
              </ToggleButton>
              <ToggleButton
                value="SELL"
                sx={{
                  '&.Mui-selected': {
                    backgroundColor: '#f44336',
                    color: '#fff',
                    '&:hover': {
                      backgroundColor: '#da190b',
                    },
                  },
                }}
              >
                Sell
              </ToggleButton>
            </ToggleButtonGroup>
          </Box>
          <Box style={{ margin: 10 }}>
            <MobileDatePicker
              name="timestamp"
              label="Date"
              inputFormat="dd/MM/yyyy"
              value={addTransactionFormData.timestamp}
              onChange={handleDateChange}
              renderInput={(params) => <TextField {...params} />}
            />
          </Box>
          <TextField
            type="number"
            name="shares"
            style={{ margin: 10 }}
            label="Shares"
            inputProps={{ step: 'any', min: 0 }}
            onChange={handleAddTransaction}
          />
          <TextField
            type="number"
            name="price"
            style={{ margin: 10 }}
            label="Price"
            inputProps={{ step: 'any', min: 0 }}
            onChange={handleAddTransaction}
          />
          <Divider />
          <Box style={{ margin: 10 }}>
            <Button variant="contained" endIcon={<AddCard />} type="submit">
              Add transaction
            </Button>
          </Box>
        </form>
      </DialogContent>
    </Dialog>
  );
}
